import { getDisabledCenters } from "./migrationService";

const ALLOWED_PATHS = ['user-service/users/switch-role', 'disabled-centers', 'reporting-service/report/get', 'reporting-service/report/generate']

const fetchDisabledCenters = async () => {
  const response = await getDisabledCenters();

  if (response) {
    // Extract the disabledCenters array from the response
    if (response.disabledCenters && Array.isArray(response.disabledCenters)) {
      return response.disabledCenters;
    }
  }

  return [];
}

export const handleDisableUpdateForCenter = async (
  data: any = {},
  method = "",
  url = ""
) => {
  // Allow operations for specific paths
  if (url && ALLOWED_PATHS.some(path => url.includes(path))) {
    return true
  }

  // Define mutating methods
  const mutatingMethods = ["POST", "PUT", "PATCH", "DELETE"]
  const isMutatingMethod = mutatingMethods.includes(method.toUpperCase())

  // If not a mutating method, allow the operation
  if (!isMutatingMethod) {
    return true
  }

  const currentRole = sessionStorage.getItem("currentRole")
  const currentCenter = sessionStorage.getItem("currentCenter")

  let disabledCenters = await fetchDisabledCenters();

  // Check if current center is disabled
  const disabledCenter = disabledCenters.find(
    (center: any) => center.id === currentCenter
  )

  // Check if data has centerId matching any disabled center
  if (data) {
    const centerFields = ["fromCenterId", "toCenterId"]
    for (const field of centerFields) {
      if (data[field]) {
        const matchedCenter = disabledCenters.find(
          (center: any) => center.id === data[field]
        )
        if (matchedCenter) {
          throw new Error(
            `${matchedCenter.name} has been disabled. Modifications are not allowed.`
          )
        }
      }
    }
  }

  // Check if URL contains a disabled center ID
  if (url && isMutatingMethod) {
    for (const center of disabledCenters) {
      if (url.includes(center.id)) {
        throw new Error(
          `${center.name} has been disabled. Modifications are not allowed.`
        )
      }
    }
  }

  // Block mutating operations for disabled centers
  if (disabledCenter && isMutatingMethod) {
    throw new Error(
      `${disabledCenter.name} has been disabled. Modifications are not allowed.`
    )
  }

  return true
}